import { render, staticRenderFns } from "./MBPBranches.vue?vue&type=template&id=94a3b0b6&scoped=true"
import script from "./MBPBranches.vue?vue&type=script&lang=js"
export * from "./MBPBranches.vue?vue&type=script&lang=js"
import style0 from "./MBPBranches.vue?vue&type=style&index=0&id=94a3b0b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94a3b0b6",
  null
  
)

export default component.exports